import { z } from 'zod';
import { objectIdSchema } from './common.schema';
import { orgUnitSummarySchema } from './orgUnit.schema';
import { rankSummarySchema } from './rank.schema';

/**
 * FR-3.1 — "every change writes a posting-history row with effective dates."
 *
 * A row is written on officer CREATION as well as on every transfer, so an officer
 * always has exactly one open posting (`toDate === null`) and the history is never
 * missing its first entry. That invariant is enforced by a unique partial index in the
 * database, not merely by the service that maintains it.
 */
export const postingHistorySchema = z.object({
  id: objectIdSchema,
  officerId: objectIdSchema,
  orgUnitId: objectIdSchema,
  rankId: objectIdSchema,
  fromDate: z.iso.datetime(),
  /** `null` = the current posting. Exactly one open row per officer, ever. */
  toDate: z.iso.datetime().nullable(),
  orgUnit: orgUnitSummarySchema.nullable(),
  rank: rankSummarySchema.nullable(),
  createdAt: z.iso.datetime(),
});
